<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="dark" fixed="top" class="bg-colorful">
      <b-navbar-brand href="/"><img width="64" style="margin-right: 10px;" src="@/assets/logo_dao.png">Fidelity
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item v-show="showMembership">
            <b-link :active="$route.path === '/memberships'" class="nav-link" to="memberships">Adesioni</b-link>
          </b-nav-item>
          <b-nav-item v-show="showMembership">
            <b-link :active="$route.path === '/monitor'" class="nav-link" to="monitor">Monitoraggio</b-link>
          </b-nav-item>
          <b-nav-item v-show="showErrors">
            <b-link :active="$route.path === '/errors'" class="nav-link" to="errors">Errori</b-link>
          </b-nav-item>

          <b-nav-item-dropdown no-caret v-show="showMembership">
            <template #button-content>
              <div style="margin-top: 8%">Digitalizzazione
                <b-icon-triangle-fill style="height: 0.6rem; vertical-align: middle; margin-left: 0.3rem" rotate="180"/>
              </div>
            </template>
            <b-dropdown-item id="new-agreement">
              <b-link :active="$route.path === '/new-agreement'" class="nav-link" to="new-agreement">Nuovi Regolamenti
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item id="digitalization">
              <b-link :active="$route.path === '/digitalization'" class="nav-link" to="digitalization">Pregresso
              </b-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item v-show="showCustomers">
            <b-link :active="$route.path === '/customers'" class="nav-link" to="customers">Anagrafiche</b-link>
          </b-nav-item>
          <b-nav-item v-show="showWarnings">
            <b-link :active="$route.path === '/warnings'" class="nav-link" to="warnings">Segnalazioni
              <b-badge v-if="notifications !== '0'" variant="warning">{{ notifications }}</b-badge>
            </b-link>
          </b-nav-item>
          <b-nav-item v-show="showShops">
            <b-link :active="$route.path === '/shops'" class="nav-link" to="shops">Negozi</b-link>
          </b-nav-item>
          <b-nav-item v-show="showDevices">
            <b-link :active="$route.path === '/devices'" class="nav-link" to="devices">Dispositivi</b-link>
          </b-nav-item>
          <b-nav-item-dropdown no-caret v-show="showAutoshop">
            <template #button-content>
              <div style="margin-top: 8%">Autonomous Store
                <b-icon-triangle-fill style="height: 0.6rem; vertical-align: middle; margin-left: 0.3rem" rotate="180"/>
              </div>
            </template>
            <b-dropdown-item>
              <b-link :active="$route.path === '/sensei/anagraphic'" class="nav-link" to="sensei_anagraphic">
                Anagrafica
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link :active="$route.path === '/sensi/charges'" class="nav-link" to="sensei_charges">Addebiti</b-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item right>
            <b-button @click="showAlert">
              <b-icon icon="question-circle-fill"></b-icon>
            </b-button>
          </b-nav-item>
          <b-nav-item right>
            <a id="logout" class="nav-link" @click="session.logout()" href="#">Logout</a>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>

import SockJS from 'sockjs-client'
import eventBus from "@/EventBus";
import WarningsApi from "@/api/WarningsApi";

const sockJS = new SockJS("/notifications")

export default {
  name: 'Navigation',
  props: ['session'],
  data: () => {
    return {
      notifications: "0"
    }
  },
  created() {
    WarningsApi.count().then(res => this.setNotifications(res.count))
    if (this.$route.path === '/') {
      if (this.showMembership) {
        this.$router.push('/memberships')
      } else if (this.showCustomers) {
        this.$router.push('/customers')
      } else if (this.showWarnings) {
        this.$router.push('/warnings')
      } else if (this.showDevices) {
        this.$router.push('/devices')
      } else if (this.showShops) {
        this.$router.push('/shops')
      } else if (this.showAutoshop) {
        this.$router.push('/sensei/anagraphic')
      }
    }
  },
  mounted() {
    eventBus.$on("received-new-warnings", this.setNotifications)

    sockJS.onopen = function () {
      console.log('Socket was opened')
    }

    sockJS.onmessage = function (message) {
      console.log('Questo è un messaggio che abbiamo ricevuto', message.data)
      eventBus.$emit("received-new-warnings", message.data)
    }
  },
  computed: {
    showErrors() {
      return this.session.tokenParsed.realm_access.roles.includes('membership_ditech_errors_management')
    },
    showAutoshop() {
      return this.session.tokenParsed.realm_access.roles.includes('autonomous_store_visualization')
    },
    showMembership() {
      return this.session.tokenParsed.realm_access.roles.includes('membership_visualization')
    },
    showCustomers() {
      return this.session.tokenParsed.realm_access.roles.includes('customer_visualization')
    },
    showWarnings() {
      return this.session.tokenParsed.realm_access.roles.includes('warnings_visualization')
    },
    showDevices() {
      return this.session.tokenParsed.realm_access.roles.includes('device_visualization')
    },
    showShops() {
      return this.session.tokenParsed.realm_access.roles.includes('shop_visualization')
    }
  },
  methods: {
    setNotifications(value) {
      this.notifications = value
    },
    showAlert() {
      eventBus.$emit("show-alert")
    }
  }
}
</script>

<style>
.navbar.bg-colorful, .dropdown-menu.show {
  background-color: #485461;
  background-image: linear-gradient(315deg, #485461 0%, #28313b 74%);
}

.nav-link {
  font-weight: bold;
  border: transparent solid 2px;
  border-radius: 5px;
}

.nav-link.router-link-active.active {
  font-weight: bold;
  color: #28313b !important;
  border: #fff solid 2px;
  background-color: #fff;
  -webkit-box-shadow: 2px 3px 5px rgb(255 255 255 / 13%);
  box-shadow: 2px 3px 5px rgb(255 255 255 / 13%);
}

.dropdown-item:hover, .dropdown-item:focus {
  background-color: unset !important;
}
</style>
